import { forwardRef } from "react";
import { styled, type TypographyProps } from "~/common/mui";
import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";
import { StockIndicatorV2 } from "~/domains/product/components/StockIndicator/StockIndicator";

type Props = BaseProductElementProps & Omit<TypographyProps, "children">;

export const StockIndicator = forwardRef<HTMLElement, Props>((props) => {
  const product = useProductContext(props);

  if (!userHasPermission(Permission.AVAILABILITY)) {
    return null;
  }

  return <StyledStockIndicator stock={product.stockAmount ?? 0} className={props.className} />;
});

const StyledStockIndicator = styled(StockIndicatorV2)(({ theme }) => ({
  width: "fit-content",
  gap: theme.spacing(0.5),
}));
